module.exports = __webpack_public_path__ + "img/max-file-content-signature-subtract.1ca0f103.svg";